import { useDispatch, useSelector } from 'react-redux';
import { isMobileLayout } from 'components/Shared/responsive';
import { Contact } from './contact';
import { Offer } from './offer';
import { Social } from './social';
import { Links } from './links';
import { SafeECom } from './safeecom';
import { Logo } from './logo';
import styles from './footer.scss';
import { GtmFooterNavClick } from 'store/googleTagManager/actions';

export type FooterItemProps = {
  onNavClick: (url: string) => void;
};

export const Footer = () => {
  const mobile = useSelector(isMobileLayout);

  return <footer className={styles.footer}>{mobile ? <FooterMobile /> : <FooterDesktop />}</footer>;
};

const FooterMobile = () => {
  const reduxDispatch = useDispatch();

  const handleOnNavClick = (url: string) => {
    reduxDispatch(GtmFooterNavClick(url));
  };

  return (
    <div className={styles.mobile}>
      <Contact className={styles.contact} />
      <Offer className={styles.offer} onNavClick={handleOnNavClick} />
      <Social className={styles.social} />
      <Links className={styles.links} onNavClick={handleOnNavClick} />
      <SafeECom className={styles.safeECom} />
      <Logo />
    </div>
  );
};

const FooterDesktop = () => {
  const reduxDispatch = useDispatch();

  const handleOnNavClick = (url: string) => {
    reduxDispatch(GtmFooterNavClick(url));
  };

  return (
    <div className={styles.desktop}>
      <div className={styles.left}>
        <Offer className={styles.offer} onNavClick={handleOnNavClick} />
        <SafeECom className={styles.safeECom} />
      </div>
      <div className={styles.top}>
        <Contact className={styles.contact} />
      </div>
      <div className={styles.topRight}>
        <Social className={styles.social} />
      </div>
      <div className={styles.bottomLeft}>
        <Logo />
      </div>
      <div className={styles.bottomRight}>
        <Links className={styles.links} onNavClick={handleOnNavClick} />
      </div>
    </div>
  );
};
